module.exports = __webpack_public_path__ + "images/ac2a8bb197357fddbd58c67e60a63210.svg";